import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/homeService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";
import moment from "moment";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();

  source;
  historyTable = "historyHomeKepegawaianTableActive";
  defaultOrder = "employee_current_work_unit_hirarki";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: false,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    // console.log("Jumlah Status Data yang Dipilih:", this.props.selectedStatusData.length);
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    let additionalFilter = this.props.additionalFilter;

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      load_data: 1, // data pegawai
      ...additionalFilter,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        //this.inactiveData()
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  handleDownloadDRH = (uuid) => {
    this.indexBloc.fetchDownloadDRH({
      uuid: uuid,
    });
  };

  componentDidMount() {
    // this.setTokenAPI()

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.downloadDRHChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
    this.dataTableBloc.inactiveChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_nip",
      text: "NIP",
      className: "employee_nip",
      sortable: true,
      width: "80",
    },
    {
      key: "employee_full_name",
      text: "Nama",
      className: "employee_full_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "employee_current_work_unit_name",
      text: "Unit Kerja",
      className: "employee_current_work_unit_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "employee_current_position_name",
      text: "Jabatan",
      className: "employee_current_position_name",
      sortable: true,
    },
    {
      key: "employee_categories_name_full",
      text: "Status Pegawai",
      className: "employee_categories_name_full",
      sortable: true,
      align: "center",
      width: 200,
      cell: (record) => {
        // ketika PPPK
        if (
          record.employee_categories_uuid ===
          "5bb0bf78-6b49-47c3-9f41-0e36fe0b0a0b"
        ) {
          return (
            <span>
              <div>{record.employee_categories_name_full}</div>
            </span>
          );
        } else {
          return (
            <span>
              <div>{record.employee_categories_name_full}</div>
              <label>({record.employee_status_name})</label>
            </span>
          );
        }
      },
    },
    // {
    //     key: "employee_status_name",
    //     text: "Status Pegawai",
    //     className: "employee_status_name",
    //     sortable: true,
    //     align: 'center',
    //     width: 120,
    // },
    {
      key: "need_approval",
      text: "Status Data",
      className: "need_approval",
      sortable: true,
      align: "center",
      width: 120,
      cell: (record) => {
        var need_approval = 0;
        var status = record.employee_status;
        // if (this.props.selectedStatusData.value == 2) {
        //   need_approval = record.employee_family_approval_request;
        // } else if (this.props.selectedStatusData.value == 3) {
        //   need_approval = record.employee_data_approval_request;
        // } else if (this.props.selectedStatusData.value == 4) {
        //   need_approval = record.employee_education_background_approval_request;
        // } else {
          // need_approval = record.need_approval;
          // need_approval =
          //   record.employee_family_approval_request +
          //   record.employee_data_approval_request +
          //   record.employee_education_background_approval_request;
        // }
        need_approval = record.need_approval !== undefined && record.need_approval !== null ? record.need_approval : 0;
        return (
          <span>
            {parseInt(need_approval) > 0 ? (
              <>
                {this.props.selectedStatusData ? (
                  this.props.selectedStatusData.label
                ) : (
                  <>
                    Menunggu Approval <br />
                  </>
                )}
                <label className="badge rounded-pill bg-soft-warning font-size-12">
                  {need_approval} Data
                </label>
              </>
            ) : (
              <>
                {status == 0 ? (
                  <>
                    <label className="badge rounded-pill bg-soft-danger font-size-12">
                      Belum Approve
                    </label>
                  </>
                ) : (
                  <label className="badge rounded-pill bg-soft-info font-size-12">
                    Aktif
                  </label>
                )}
              </>
            )}
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.employee_id;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.employee_uuid,
                  });

                  // set current employee uuid selected
                  let dataUser = {
                    employee_uuid: record.employee_uuid,
                    employee_name: record.employee_name,
                    employee_full_name: record.employee_full_name,
                    employee_current_position_name:
                      record.employee_current_position_name,
                    employee_current_position_uuid:
                      record.employee_current_position_uuid,
                    employee_nip: record.employee_nip,
                    employee_categories_uuid: record.employee_categories_uuid,
                    position_grade: record.position_grade,
                  };
                  localStorage.setItem(
                    "employeeSelected",
                    JSON.stringify(dataUser)
                  );
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-search-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Lihat
              </Tooltip>
            </span>

            <span>
              <button
                className="btn btn-warning btn-sm"
                id={"drh-" + thisId}
                onClick={() => {
                  this.handleDownloadDRH(record.employee_uuid);
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-download"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["drh" + thisId]}
                target={"drh-" + thisId}
                toggle={() => {
                  this.setState({
                    ["drh" + thisId]: !this.state["drh" + thisId],
                  });
                }}
              >
                Download Data Riwayat Hidup
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Memproses data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diproses"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
          <Redirect to={"/kepegawaian/home.html?identitas"} />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
